import { SearchOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Col, Input, Popconfirm, Row, Space, Table, Tooltip } from 'antd';
import dayjs from 'dayjs';
import { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { ReactComponent as ArchiveRestore } from '../../Images/ArchiveRestore.svg';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { ReactComponent as FilterIcon } from '../../Images/FilterIcon.svg';

function ArchiveBundleInWard() {
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);
    const [pagesize, setPageSize] = useState(10);
    const [orderBy, setOrderBy] = useState('');
    const dispatch = useDispatch();

    const { data = [], totalRecord, status } = useSelector(state => state.quotation);

    const dataSource = data.map((item, index) => ({
        ...item,
        key: item.id || index,
        SrNo: (page - 1) * pagesize + index + 1,
    }));

    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const debounceTimeout = useRef(null);
    const handleSearch = (e) => {
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }

        debounceTimeout.current = setTimeout(() => {
            setSearch(e.target.value);
            setPage(1);
        }, 100);
    };
    const GetSortingEnumValue = (sortField, sortOrder) => {
        let sortingEnumKey = "id";

        if (sortField === "bundle_no" && sortOrder === "ascend") {
            sortingEnumKey = "bundle_no";
        }
        if (sortField === "bundle_no" && sortOrder === "descend") {
            sortingEnumKey = "-bundle_no";
        }
        if (sortField === "shift" && sortOrder === "ascend") {
            sortingEnumKey = "shift";
        }
        if (sortField === "shift" && sortOrder === "descend") {
            sortingEnumKey = "-shift";
        }
        if (sortField === "die_profile" && sortOrder === "ascend") {
            sortingEnumKey = "die_profile__die_number";
        }
        if (sortField === "die_profile" && sortOrder === "descend") {
            sortingEnumKey = "-die_profile__die_number";
        }
        if (sortField === "length" && sortOrder === "ascend") {
            sortingEnumKey = "length";
        }
        if (sortField === "length" && sortOrder === "descend") {
            sortingEnumKey = "-length";
        }
        if (sortField === "item_name" && sortOrder === "ascend") {
            sortingEnumKey = "item_name";
        }
        if (sortField === "item_name" && sortOrder === "descend") {
            sortingEnumKey = "-item_name";
        }
        if (sortField === "pieces" && sortOrder === "ascend") {
            sortingEnumKey = "pieces";
        }
        if (sortField === "pieces" && sortOrder === "descend") {
            sortingEnumKey = "-pieces";
        }
        if (sortField === "weight" && sortOrder === "ascend") {
            sortingEnumKey = "weight";
        }
        if (sortField === "weight" && sortOrder === "descend") {
            sortingEnumKey = "-weight";
        }
        if (sortField === "avg_weight" && sortOrder === "ascend") {
            sortingEnumKey = "avg_weight";
        }
        if (sortField === "avg_weight" && sortOrder === "descend") {
            sortingEnumKey = "-avg_weight";
        }
        if (sortField === "gross_weight" && sortOrder === "ascend") {
            sortingEnumKey = "gross_weight";
        }
        if (sortField === "gross_weight" && sortOrder === "descend") {
            sortingEnumKey = "-gross_weight";
        }
        if (sortField === "packing_date" && sortOrder === "ascend") {
            sortingEnumKey = "packing_date";
        }
        if (sortField === "packing_date" && sortOrder === "descend") {
            sortingEnumKey = "-packing_date";
        }
        if (sortField === "dispatch_date" && sortOrder === "ascend") {
            sortingEnumKey = "dispatch_date";
        }
        if (sortField === "dispatch_date" && sortOrder === "descend") {
            sortingEnumKey = "-dispatch_date";
        }
        if (sortField === "alloy" && sortOrder === "ascend") {
            sortingEnumKey = "alloy__name";
        }
        if (sortField === "alloy" && sortOrder === "descend") {
            sortingEnumKey = "-alloy__name";
        }
        if (sortField === "packing_type" && sortOrder === "ascend") {
            sortingEnumKey = "packing_type";
        }
        if (sortField === "packing_type" && sortOrder === "descend") {
            sortingEnumKey = "-packing_type";
        }
        if (sortField === "hardness" && sortOrder === "ascend") {
            sortingEnumKey = "hardness";
        }
        if (sortField === "hardness" && sortOrder === "descend") {
            sortingEnumKey = "-hardness";
        }
        if (sortField === "status" && sortOrder === "ascend") {
            sortingEnumKey = "status";
        }
        if (sortField === "status" && sortOrder === "descend") {
            sortingEnumKey = "-status";
        }
        if (sortField === "packed_by" && sortOrder === "ascend") {
            sortingEnumKey = "packed_by";
        }
        if (sortField === "packed_by" && sortOrder === "descend") {
            sortingEnumKey = "-packed_by";
        }
        if (sortField === "created_at" && sortOrder === "ascend") {
            sortingEnumKey = "created_at";
        }
        if (sortField === "created_at" && sortOrder === "descend") {
            sortingEnumKey = "-created_at";
        }
        if (sortField === "created_by" && sortOrder === "ascend") {
            sortingEnumKey = "created_by";
        }
        if (sortField === "created_by" && sortOrder === "descend") {
            sortingEnumKey = "-created_by";
        }
        if (sortField === "updated_at" && sortOrder === "ascend") {
            sortingEnumKey = "updated_at";
        }
        if (sortField === "updated_at" && sortOrder === "descend") {
            sortingEnumKey = "-updated_at";
        }
        if (sortField === "updated_by" && sortOrder === "ascend") {
            sortingEnumKey = "updated_by";
        }
        if (sortField === "updated_by" && sortOrder === "descend") {
            sortingEnumKey = "-updated_by";
        }
        return sortingEnumKey;
    };

    const handleTableChange = async (pagination, filters, sorter, ordering) => {
        if (sorter?.columnKey && sorter.order) {
            const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
            setOrderBy(orderBy);
        }
        setPageSize(pagination.pageSize);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: setSelectedRowKeys,
    };
    const columns = [
        {
            title: 'Sr. No.',
            dataIndex: 'SrNo',
            key: 'SrNo',
            sorter: true,
            width: 100,
        },
        {
            title: 'Bundle No.',
            dataIndex: 'bundle_no',
            key: 'bundle_no',
            render: (bundle_no) => {
                return (
                    <span>
                        {bundle_no ? bundle_no : 'N/A'}
                    </span>
                );
            },
            sorter: true,
        },
        {
            title: 'Shift',
            dataIndex: 'shift',
            key: 'shift',
            sorter: true,
            render: (shift) => {
                return (
                    <span>
                        {shift ? shift : 'N/A'}
                    </span>
                );
            },
        },
        {
            title: 'Profile',
            dataIndex: 'workorder_detail',
            key: 'die_profile',
            sorter: true,
            render: (text, record) => {
                return (
                    <span>
                        {record.workorder_detail?.die_profile?.die_number || 'N/A'}
                    </span>
                );
            },
        },
        {
            title: 'Length(mm)',
            dataIndex: 'length',
            key: 'length',
            sorter: true,
            render: (length) => {
                return (
                    <span>
                        {length ? length : '0'}
                    </span>
                );
            },
        },
        {
            title: 'Item Name',
            dataIndex: 'workorder_detail',
            key: 'dimensions',
            render: (workorder_detail) => {
                if (workorder_detail && workorder_detail.die_profile) {
                    const { dimension1, dimension2, dimension3, dimension4 } = workorder_detail.die_profile;
                    return `${dimension1 || 0} x ${dimension2 || 0} x ${dimension3 || 0} x ${dimension4 || 0}`;
                }
                return 'N/A';
            }
        },
        {
            title: 'Pieces',
            dataIndex: 'pieces',
            key: 'pieces',
            sorter: true,
            render: (pieces) => {
                return (
                    <span>
                        {pieces ? pieces : 'N/A'}
                    </span>
                );
            },
        },
        {
            title: 'Weight',
            dataIndex: 'weight',
            key: 'weight',
            sorter: true,
            render: (weight) => {
                return (
                    <span>
                        {weight ? weight : 'N/A'}
                    </span>
                );
            },
        },
        {
            title: 'Avg Weight',
            dataIndex: 'avg_weight',
            key: 'avg_weight',
            sorter: true,
            render: (avg_weight) => {
                return (
                    <span>
                        {avg_weight ? avg_weight : '0'}
                    </span>
                );
            },
        },
        {
            title: 'Gross Weight',
            dataIndex: 'gross_weight',
            key: 'gross_weight',
            sorter: true,
            render: (gross_weight) => {
                return (
                    <span>
                        {gross_weight ? gross_weight : 'N/A'}
                    </span>
                );
            },
        },
        {
            title: 'Packing Date',
            dataIndex: 'packing_date',
            key: 'packing_date',
            render: record => {
                return (
                    <span>{record ? dayjs(record).format('DD-MM-YYYY') : 'N/A'} </span>
                );
            },
            sorter: true,
        },
        {
            title: 'Dispatch Date',
            dataIndex: 'dispatch_date',
            key: 'dispatch_date',
            render: record => {
                return (
                    <span>{record ? dayjs(record).format('DD-MM-YYYY') : 'N/A'} </span>
                );
            },
            sorter: true,
        },
        {
            title: 'Alloy Type',
            dataIndex: 'alloy',
            key: 'alloy',
            sorter: true,
            render: (alloy) => {
                return (
                    <span>
                        {alloy && (alloy.name || alloy.color_code)
                            ? `${alloy.name || ''}${alloy.name && alloy.color_code ? ' - ' : ''}${alloy.color_code || ''}`
                            : 'N/A'}
                    </span>
                );
            },
        },
        {
            title: 'Packing Type',
            dataIndex: 'workorder',
            key: 'packing_type',
            sorter: true,
            render: (workorder) => {
                return workorder?.packing_type?.length
                    ? workorder.packing_type.join(', ')
                    : 'N/A';
            },
        },
        {
            title: 'Hardness',
            dataIndex: 'hardness',
            key: 'hardness',
            sorter: true,
            render: (hardness) => {
                return (
                    <span>
                        {hardness ? hardness : 'N/A'}
                    </span>
                );
            },
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (status) => {
                return (
                    <span>
                        {status ? status : 'N/A'}
                    </span>
                );
            },
            sorter: true,
        },
        {
            title: 'Packed By',
            dataIndex: 'packed_by',
            key: 'packed_by',
            sorter: true,
            render: (packed_by) => {
                return (
                    <span>
                        {packed_by ? packed_by : 'N/A'}
                    </span>
                );
            },
        },
        {
            title: 'Archive At',
            dataIndex: 'updated_at',
            key: 'updated_at',
            render: (record) => {
                return record ? (
                    <span>{dayjs(record).format('DD-MM-YYYY HH:mm')}</span>
                ) : (
                    <span>N/A</span>
                );
            }
        },
        {
            title: 'Archive By',
            dataIndex: 'updated_by',
            key: 'updated_by',
            render: (record) => {
                return (
                    <span>{record ? `${record.first_name} ${record.last_name}` : 'N/A'} </span>
                )
            }

        },
        {
            title: 'Action',
            dataIndex: 'action',
            fixed: 'right',
            width: 100,
            render: (_, record) => (
                <Space>
                    <Tooltip placement="top" title="Restore">
                        <Popconfirm
                            title="Are you sure you want to Unarchive this record?"
                            okText="Yes"
                            cancelText="No"
                        >
                            <ArchiveRestore className="ArchiverestorImg" />
                        </Popconfirm>
                    </Tooltip>
                </Space>
            ),
        },
    ];
    const handlePageChange = (newPage) => {
        setPage(newPage);
        setOrderBy('')
    };
    const resetFilter = () => {
        setSearch('');
        setOrderBy('');
        setPage(1);
    };
    return (
        <>
            <div className='sticyaction'>
                <Row className="pagenamerow" justify="space-between" align="middle">
                    <Col>
                        <h2>Archive Bundle Inward</h2>
                        <div className="bredcrumbwrp">
                            <Link to="/bundle-inward" className="back">
                                <Back /> BACK
                            </Link>
                            <Breadcrumb
                                items={[
                                    { title: <Link to="/dashboard">Home</Link> },
                                    { title: <Link to="/bundle-inward">Bundle Inward</Link> },
                                    { title: 'Archive Bundle Inward' }
                                ]}
                            />
                        </div>
                    </Col>
                    <Col>
                        <Space size="middle">
                            <Input placeholder="Search"
                  className='searchbox'
                                value={search}
                                onChange={handleSearch}
                                prefix={<SearchOutlined />} style={{ width: 200 }} />
                            <Link>
                                <Tooltip title="Filter">
                                    <Button type="primary" disabled={!search && !orderBy} className='iconlink' onClick={resetFilter}>
                                        <FilterIcon />
                                    </Button>
                                </Tooltip>
                            </Link>
                        </Space>
                    </Col>
                </Row>
            </div>
            <div style={{ position: 'sticky', top: 0, zIndex: 1000, background: '#fff' }}>

            <Table
                rowSelection={rowSelection}
                dataSource={dataSource}
                columns={columns}
                pagination={{
                    defaultCurrent: page,
                    defaultPageSize: pagesize,
                    total: totalRecord,
                    showTotal: (total) => `Total ${total} items`,
                    showSizeChanger: true,
                    onChange: handlePageChange,
                    locale: {
                        items_per_page: 'Items / Page',
                    },
                }}
                className="mt-5"
                onChange={handleTableChange}

                scroll={{
                    x: 2500, // Horizontal Scroll
                    y: 400,  // Vertical Scroll with Fixed Header
                  }}
            />
            </div>
        </>
    );
}

export default ArchiveBundleInWard;